import React, { useContext, useEffect, useMemo, useRef } from "react";
import { useState } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import STcontext from "../../../context/STcontext";
import { MDBIcon } from "mdb-react-ui-kit";
import ThreeDot from "../../../loading/Three dots/Three_dot";
import { Checkbox } from "primereact/checkbox";
import ComptableContext from "../../../context/ComptableContext";

export default function ImportSim() {
   const {
      modeles,
      readExcelFile,
      handleImportSim,
      importSimSubmit,
      showImportSim,
      simNotImporter,
      setShowImportSim,
      setSimNotImporter,
      isLoading,
      errorsMessages,
   } = useContext(STcontext);
      const { alltype, getAllTypes } = useContext(ComptableContext);

   const [errorMessage, setErrorMessage] = useState([]);
   const [simModel, setSimModel] = useState([]);
   const [checked, setChecked] = useState(false);

   const handleClose = () => {
      setShowImportSim(false);
      setSimNotImporter([]);
   };
   const handleShow = () => {
      setShowImportSim(true);
   };

   const handleLoadSimTypes = useMemo(() => {
      const typesOfSIM = alltype.filter((type) => type.appareil_id == 2);
      const simTypes = typesOfSIM?.map((type) => type.modeles);
      return simTypes.flat();
   }, [alltype]);

   const simNotImportedBody = (simNotImporter) => {
      return (
         <>
            <hr />
            <h6>Sim Non Importer:</h6>
            {simNotImporter.map((sim, index) => (
               <ul key={index} style={{ display: "inline-block" }}>
                  <li>{sim}</li>
               </ul>
            ))}
         </>
      );
   };

   return (
      <div>
         <Button variant="primary" onClick={handleShow}>
            <MDBIcon fas icon="download" /> Import SIM{" "}
         </Button>

         <Modal show={showImportSim} onHide={handleClose}>
            <Modal.Header closeButton>
               <Modal.Title>Import SIM</Modal.Title>
            </Modal.Header>
            <Modal.Body>
               <Form noValidate method="POST" onSubmit={(e) => importSimSubmit(e, checked, setChecked)}>
                  <Row>
                     <Form.Group
                        as={Col}
                        className="mb-3"
                        controlId="validationCustom04"
                     >
                        <Form.Label>Modele appareil &nbsp;
                           <span className="star-Mandatory-field">*</span> &nbsp;:{" "}</Form.Label>
                        <Form.Select
                           onChange={handleImportSim}
                           aria-label="Default select example"
                           name="modele_id"
                        >
                           <option value="none" selected disabled hidden>
                              Select Model
                           </option>
                           <option disabled>Select Model</option>
                           {handleLoadSimTypes &&
                              handleLoadSimTypes.map((model) => (
                                 <option key={model.id}>{model.nameModele}</option>
                              ))}
                        </Form.Select>
                        <span style={{ color: "red" }}>
                                    {errorsMessages && errorsMessages.modele_id
                                       ? errorsMessages.modele_id[0]
                                       : ""}
                                 </span>
                     </Form.Group>
                  </Row>
                  <Row>
                     <Form.Group as={Col} className="mb-3" controlId="formFile">
                        <Form.Label>Select File &nbsp;
                           <span className="star-Mandatory-field">*</span> &nbsp;:{" "}</Form.Label>
                        <Form.Control
                           type="file"
                           accepte=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                           onChange={(e) => {
                              const file = e.target.files[0];
                              readExcelFile(file);
                           }}
                           name="simFile"
                        />
                        <span style={{ color: "red" }}>
                                    {errorsMessages && errorsMessages.simFile
                                       ? errorsMessages.simFile[0]
                                       : ""}
                                 </span>
                     </Form.Group>
                  </Row>
                  <Form.Group as={Col} className="mb-3" controlId="validationCustom04">
                     <Form.Label>Etat de la SIM <span style={{ color: "red" }}>* </span>:</Form.Label>
                     <Form.Select
                        onChange={handleImportSim}
                        name="garantie"
                     >

                        <option disabled>Select Etat</option>
                        <option selected disabled value="none">SIM etat</option>
                        <option value={1}>Nouveaux</option>
                        <option value={0}>Remplacement</option>
                     </Form.Select>
                     <span style={{ color: "red" }}>
                        {errorsMessages && errorsMessages.garantie
                           ? errorsMessages.garantie[0]
                           : ""}
                     </span>
                  </Form.Group>
                  {errorMessage && <p>{errorMessage}</p>}

                  <Form.Group
                     className="mb-3"
                     controlId="exampleForm.ControlTextarea1"
                  >
                     <Form.Label>Observation</Form.Label>
                     <Form.Control
                        name="observation"
                        onChange={handleImportSim}
                        as="textarea"
                        rows={3}
                     />
                  </Form.Group>

                  {simNotImporter.length > 0
                     ? simNotImportedBody(simNotImporter)
                     : ""}
                  <Modal.Footer>
                     <Button type="submit" variant="primary" disabled={isLoading}>
                        {!isLoading ? "Importer" : <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "2px" }}>en cours <ThreeDot /></div>}
                     </Button>
                  </Modal.Footer>
               </Form>
            </Modal.Body>
         </Modal>
      </div>
   );
}
